import { TextField, withStyles, InputAdornment } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFolderSearch } from "../../Stores/FolderAction/actions";
import SearchIcon from "@material-ui/icons/Search";

const StyledTextField = withStyles({
  root: {
    width: "100%",
    maxWidth: 280,
    backgroundColor: "#fff",
    borderRadius: 10,
    border: "1px solid #E3E1DB",
    "& .MuiOutlinedInput-root": {
      height: 36,
      paddingLeft: 8,
      paddingRight: 8,
      borderRadius: 10,
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: 8,
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px 8px 0",
      fontSize: 13,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputAdornment-root": {
      marginRight: 4,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 18,
      color: "#797160",
    },
  },
})(TextField);

const PolicySearchCard = () => {
  const dispatch = useDispatch();
  const { folderSearch } = useSelector((state) => state.FolderActionReducer);

  const updateFilter = (value) => {
    dispatch(updateFolderSearch(value));
  };

  return (
    <StyledTextField
      variant="outlined"
      size="small"
      placeholder="Search folder, file"
      value={folderSearch ?? ""}
      onChange={(e) => updateFilter(e?.target?.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default React.memo(PolicySearchCard);
